import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { EIP6963ProviderDetail } from '@blink/components/src/utils/wallet/types';
import { useDispatch } from 'react-redux';
import {
    NETWORK,
    NETWORK_CHAIN_TO_NETWORK,
    UNSUPPORTED_NETWORK_ID,
} from '@blink/components/src/constants/global';

import { walletStore } from '@/context/walletStore';
import {
    addWalletsSaga,
    removeWallets,
    changeNetworkSagaAction,
} from '@/shared/store/wallets/actions';

interface ProvidersProviderProps {
    children: ReactNode;
}
const ProvidersContext = createContext<EIP6963ProviderDetail[]>([]);

export const ProvidersProvider: React.FC<ProvidersProviderProps> = ({ children }) => {
    const [providers, setProviders] = useState<EIP6963ProviderDetail[]>(walletStore.value());
    const dispatch = useDispatch();

    useEffect(() => {
        const unsubscribe = walletStore.subscribe(
            () => {
                setProviders(walletStore.value());
            },
            (providerName, wallets) => {
                if (wallets.length) {
                    dispatch(addWalletsSaga(providerName));
                } else {
                    dispatch(removeWallets());
                }
            },
            (chainId) => {
                const network: NETWORK =
                    NETWORK_CHAIN_TO_NETWORK.get(chainId) || (UNSUPPORTED_NETWORK_ID as NETWORK);

                dispatch(changeNetworkSagaAction(network));
            },
        );

        return () => unsubscribe();
    }, []);

    return <ProvidersContext.Provider value={providers}>{children}</ProvidersContext.Provider>;
};

export const useProviders = () => useContext(ProvidersContext);
